const seoConfig = {
  default: {
    title: 'İskenderun Belediyesi',
    description: 'İskenderun Belediyesi resmi web sitesi',
  },
  routes: {
    '/basindabiz': {
      title: 'Basında Biz | İskenderun Belediyesi',
      description: 'İskenderun ve belediyemizin çalışmaları hakkında basında yer alan haberler ve yayın kuruluşları.',
    },
    '/': {
      title: 'Ana Sayfa | İskenderun Belediyesi',
      description: 'İskenderun Belediyesi resmi web sitesi. Belediye hizmetleri, duyurular, haberler ve etkinlikler.',
    },
    '/baskan': {
      title: 'Başkan | İskenderun Belediyesi',
      description: 'İskenderun Belediye Başkanı özgeçmişi ve çalışmaları.',
    },
    '/baskan-gorev-yetkileri': {
      title: 'Başkan Görev ve Yetkileri | İskenderun Belediyesi',
      description: 'İskenderun Belediye Başkanının görev ve yetkileri hakkında bilgi.',
    },
    '/misyon-vizyon-ve-temel-degerler': {
      title: 'Misyon, Vizyon ve Temel Değerler | İskenderun Belediyesi',
      description: 'İskenderun Belediyesinin misyonu, vizyonu ve temel değerleri.',
    },
    '/meclis-kararlari': {
      title: 'Meclis Kararları | İskenderun Belediyesi',
      description: 'İskenderun Belediyesi meclis kararları ve tutanakları.',
    },
    '/faaliyet-raporlari': {
      title: 'Faaliyet Raporları | İskenderun Belediyesi',
      description: 'İskenderun Belediyesi faaliyet raporları ve çalışma dökümanları.',
    },
    '/meclis-uyeleri': {
      title: 'Meclis Üyeleri | İskenderun Belediyesi',
      description: 'İskenderun Belediyesi meclis üyeleri ve komisyonları.',
    },
    '/mudurlukler': {
      title: 'Müdürlüklerimiz | İskenderun Belediyesi',
      description: 'İskenderun Belediyesi müdürlükleri ve birim yöneticileri.',
    },
    '/organizasyon-semasi': {
      title: 'Organizasyon Şeması | İskenderun Belediyesi',
      description: 'İskenderun Belediyesi organizasyon yapısı ve yönetim şeması.',
    },
    '/kurumsal-kimlik': {
      title: 'Kurumsal Kimlik | İskenderun Belediyesi',
      description: 'İskenderun Belediyesi kurumsal kimlik ve logo kullanımı.',
    },
    '/bilgi-edinme': {
      title: 'Bilgi Edinme | İskenderun Belediyesi',
      description: 'İskenderun Belediyesi bilgi edinme hakkı ve başvuru süreçleri.',
    },
    '/bilgiedinmekurum': {
      title: 'Bilgi Edinme Kurum Başvurusu | İskenderun Belediyesi',
      description: 'İskenderun Belediyesi bilgi edinme hakkı kapsamında kurum başvuru formu. 4982 Sayılı Bilgi Edinme Hakkı Kanunu çerçevesinde kurumsal bilgi edinme başvurusu yapın.',
    },
    '/bilgiedinmesahis': {
      title: 'Bilgi Edinme Şahıs Başvurusu | İskenderun Belediyesi',
      description: 'İskenderun Belediyesi bilgi edinme hakkı kapsamında şahıs başvuru formu. 4982 Sayılı Bilgi Edinme Hakkı Kanunu çerçevesinde kişisel bilgi edinme başvurusu yapın.',
    },
    '/muhtarliklar': {
      title: 'Muhtarlıklar | İskenderun Belediyesi',
      description: 'İskenderun ilçesi mahalle muhtarlıkları ve iletişim bilgileri.',
    },
    '/iskenderun-tarihi': {
      title: 'İskenderun Tarihi | İskenderun Belediyesi',
      description: 'İskenderun ilçesinin tarihi ve kültürel mirası hakkında bilgiler.',
    },
    '/iskenderun-sehir-haritasi': {
      title: 'İskenderun Şehir Haritası | İskenderun Belediyesi',
      description: 'İskenderun ilçesi interaktif şehir haritası ve önemli noktalar.',
    },
    '/temizlik-hizmetleri': {
      title: 'Temizlik Hizmetleri | İskenderun Belediyesi',
      description: 'Mahalle bazlı konteyner temizliği ve temizlik hizmetleri harita görünümü.',
    },
    '/afet-acil-toplanma-alanlari': {
      title: 'Afet ve Acil Durum Toplanma Alanları | İskenderun Belediyesi',
      description: 'İskenderun Belediyesi afet ve acil durum toplanma alanları listesi. Mahalle bazlı toplanma noktaları ve detaylı yol tarifleri.',
    },
    '/etkinlikler': {
      title: 'Etkinlikler | İskenderun Belediyesi',
      description: 'İskenderun Belediyesi kültürel ve sosyal etkinlikleri.',
    },
    '/e-odeme': {
      title: 'E-Ödeme | İskenderun Belediyesi',
      description: 'İskenderun Belediyesi online ödeme sistemi.',
    },
    '/nikah-islemleri': {
      title: 'Evlilik Hizmetleri | İskenderun Belediyesi',
      description: 'İskenderun Belediyesi nikah işlemleri ve evlilik başvurusu.',
    },
    '/kuafor-randevu': {
      title: 'Kuaför Randevu | İskenderun Belediyesi',
      description: 'İskenderun Belediyesi kuaför randevu sistemi.',
    },
    '/ihaleler': {
      title: 'İhaleler | İskenderun Belediyesi',
      description: 'İskenderun Belediyesi güncel ihaleler listesi.',
    },
    '/ilanlar': {
      title: 'İlanlar | İskenderun Belediyesi',
      description: 'İskenderun Belediyesi resmi ilanlar ve duyurular.',
    },
    '/duyurular': {
      title: 'Duyurular | İskenderun Belediyesi',
      description: 'İskenderun Belediyesi güncel duyuruları.',
    },
    '/iletisim': {
      title: 'İletişim | İskenderun Belediyesi',
      description: 'İskenderun Belediyesi iletişim bilgileri ve adres detayları.',
    },
    '/mobil-gizlilik-politikasi': {
      title: 'İskenderun Yanında Mobil Gizlilik Politikası | İskenderun Belediyesi',
      description: 'İskenderun Yanında mobil uygulamasında kişisel verilerin toplanması, kullanılması, saklanması ve silinmesi hakkında bilgi.',
    },
    '/mobil-hesap-sil': {
      title: 'İskenderun Yanında Hesap Silme | İskenderun Belediyesi',
      description: 'İskenderun Yanında mobil uygulama hesabınızı ve hesabınızla ilişkili verileri silme talebi oluşturun.',
    },
  }
};

export default seoConfig;
